var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('span',{staticClass:"official-tag",class:_vm.tagClass,attrs:{"title":_vm.tagTitle}},[(_vm.showImage)?_c('img',{attrs:{"src":_vm.imageSrc,"alt":_vm.tagTitle},on:{"error":_vm.onImageError}}):[_vm._v(_vm._s(_vm.displayText))]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }